import { createRequestActions } from '../utils';
import * as cosAnnexeTRTypes from './cosAnnexeTRTypes';

export const saveCosAnnexeTRs = createRequestActions(cosAnnexeTRTypes.SAVE_COS_ANNEXE_TRs);
export const listCosAnnexeTR = createRequestActions(cosAnnexeTRTypes.COS_ANNEXE_TR_LIST);
